import SearchFormSwitch from './SearchFormSwitch';

export default SearchFormSwitch;
